import React, {Component} from 'react';
import { storage } from '../../../firebase/index';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import axios from '../../../axios-drops';
import Input from '../Input/Input';
import withErrorHandler from '../../../containers/hoc/withErrorHandler/withErrorHandler';
import BackIconButton from '../Buttons/BackIconButton/BackIconButton'
import Button from '../Buttons/Button/Button';
import Aux from '../../../containers/hoc/Auxiliary';

import Spinner from '../Spinner/Spinner';

import noImage from '../../../Images/no-image-icon.PNG';


import classes from './AddPinTrd.css';


class AddPinTrd extends Component {

    state = {
        inputForm: {
            name: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. Storm Trooper)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Name'
            },
            variant: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. Blue Meanie)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Variant'
            }, 
            edition: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 35)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Edition'
            },
            availability: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 33)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Number Available'
            },
            cost: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 30)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Cost'
            }
        },
        formIsValid: false,
        loading: false,
        imageAlreadyUploaded: false,
        image: null,
        imageName: '',
        currentURL: "",
        unlockSave: false,
        saved: false,
        loadSuccessful: false,
        progress: 100,
        imageURL: { 
            validation: {
                required: true
            },
            valid: false,
            touched: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)

    }

    componentDidRender() {
        window.scrollTo(0, 0)
    }

    // componentWillUnmount() {
    //     if (!this.state.saved && this.state.currentURL !== '') {
    //         this.deleteImage();
    //     }
    // }



    cancelClickedHandler = props => {

        // console.log(this.state.currentURL)
        if (this.state.currentURL !== '') {
            this.deleteImage();
        }
    
        this.backClickedHandler()   
    }

    deleteImage = () => {
        storage.ref().child('images/' + this.state.imageName).delete();
    }

    saveClickedHandler = () => {

        const drop = {
            name: this.state.inputForm.name.value,
            variant: this.state.inputForm.variant.value,
            image: this.state.currentURL,
            edition: this.state.inputForm.edition.value,
            originallyAvailable: this.state.inputForm.availability.value,
            availability: this.state.inputForm.availability.value,
            cost: this.state.inputForm.cost.value,
            showInfo: false,
            current: true,
            dropClosed: false,
            type: "trd",
            imageName: this.state.imageName
        }
       
       const post = async () => {
            await axios.post('/drops.json', drop)
            .then(response => {

                if (response.status === 200) {
                    this.setState({saved: true})
                    this.backClickedHandler();
                }

            }).catch(error => console.log(error));
       }

       post()        
    }


    checkValidity(value, rules) {        
        let isValid = true;
        if(rules.required){
            isValid = value.trim() !== '';
        }
        return isValid;
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedInputForm = {
            ...this.state.inputForm
        }
      
        const updatedFormElement = {
            ...updatedInputForm[inputIdentifier]
        }
      
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = this.checkValidity(
            updatedFormElement.value, updatedFormElement.validation
        )
        updatedFormElement.touched = true;
   
        updatedInputForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for( let inputIdentifier in updatedInputForm){
            formIsValid = updatedInputForm[inputIdentifier].valid
            && formIsValid;
        }

        let unlockSaveBtn = false;
        
        if (formIsValid && this.state.currentURL !== '') {
            unlockSaveBtn = true;
        }

        this.setState({inputForm: updatedInputForm,
                        formIsValid: formIsValid,
                        unlockSave: unlockSaveBtn});
    }


    uploadImageHandler = () => {

  

        const randomSalt = this.getRandomString();
        const imageName = this.state.image.name + randomSalt

        if (!this.state.imageAlreadyUploaded) {
            const uploadTask = storage.ref('images/' + imageName).put(this.state.image);
            
           
                uploadTask.on(
                    "state_changed",
                    snapshot => {
                        const progress = Math.round(
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                        );
                        this.setState({ progress: progress });
                    },
                    error => {
                        console.log(error);
                    },
                    () => {
                        storage
                            .ref("images")
                            .child(imageName)
                            .getDownloadURL()
                            .then(url => {
                                this.setState({
                                    currentURL: url,
                                    imageAlreadyUploaded: true,
                                    unlockSave: this.state.formIsValid,
                                    imageName: imageName
                                });
                            });
                    }
                );   
        }
    };

    handleChange = event => {

        

        if (event.target.files[0]) {
            
            if (this.state.currentURL !== '') {
                this.deleteImage();  
            }
            
            this.setState({image: event.target.files[0], 
                        imageAlreadyUploaded: false})
        }
        
        setTimeout( () => {
        
            this.uploadImageHandler();
        }, 100);    
        
        
    }

    backClickedHandler = () => {
        this.props.history.goBack()
    }

    getRandomInt = () => {
        return Math.floor(Math.random() * Math.floor(8)) + 1
    }

    getRandomString = () => {
        let result = '';
        for (let i = 0; i < 10; ++i) {
            result += this.getRandomInt();
        }
        
        for(let i = 0; i < this.getRandomInt(); ++i) {
            if ( this.getRandomInt() >= 3 ) {   // random mutations
                result += this.getRandomInt();
            } 
        }
        return result;
    }

    render() {


        const formElementsArray = [];
        for (let key in this.state.inputForm){
            formElementsArray.push({
                id: key,
                config: this.state.inputForm[key]
            })
        }

        let form = (
            <form>
                {formElementsArray.map(formElement => (
                    <Input key={formElement.id}
                    elementType={formElement.config.elementType} 
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation.required}
                    touched={formElement.config.touched}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    name={formElement.config.name}/>
               ))}
            </form>
        )

       

        let image = <img src={noImage} 
            alt='not Found' className={classes.Image}/>


        if (this.state.progress !== 100) {
            image = <Spinner/>
        }

   

        if (this.state.currentURL.length > 0 && this.state.progress === 100) {
            image = <img src={this.state.currentURL} 
            alt='404: not Found' className={classes.Image}/>
        }


        let redirect = null

        if (!this.props.isAuth) {
            redirect = <Redirect to="/signin" />
        }



        return (
            <Aux>
                {redirect}
                <div className={classes.TopArea}>
                    {image}
                    
                    <div className={classes.ImageUploadGroup}  >
                        <div className={classes.FileButton}>
                            <input type="file" onChange={this.handleChange} />
                        </div>
                      
                    </div>
                    
                </div>
                <div className={classes.Form}>
                    {form}
                
                    <div className={classes.BottomArea}>
                        <Button btnType="Cancel"
                            clicked={this.cancelClickedHandler}>
                            CANCEL
                        </Button>
                        <div className={classes.SpaceBetween}></div>
                        <Button btnType="Submit" disabled={!this.state.unlockSave}
                            clicked={this.saveClickedHandler}>
                            SAVE
                        </Button>
                    </div>
                </div>  
                <BackIconButton clicked={this.backClickedHandler}/> 
        </Aux>  
            
        )
    }
}


const mapStateToProps = (state) => {
    return {
        isAuth: state.token !== null
    }
}



export default connect(mapStateToProps)(withErrorHandler(AddPinTrd, axios));



// WEBPACK FOOTER //
// ./src/components/UI/AddPinTrd/AddPinTrd.js